import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { deleteConfigPtMonDigital } from './services'

const initialState: any = {
  status: "",
  data: []
}

export const actionDeleteConfigPtMonDigital: any = createAsyncThunk<any, any>(
  "ACTION_DELETE_CONFIG_PT_MON_DIGITAL",
  async (_, { getState }: any) => {
    const {
      modulosByCentral: {
        entradaSelected: {
          modulo: {
            idCentral,
            adrModulo,
          },
          entrada
        }
      },
    } = getState()
    return deleteConfigPtMonDigital({
      idCentral,
      adrModulo,
      idEntrada: entrada.id,
    })
  }
)

const sliceDeleteConfigPtMonDigital = createSlice({
  name: "DELETE_CONFIG",
  initialState,
  reducers: {
    actionResetDeleteConfigPtMonDigital: (state) => {
      state.status = ""
    }
  },
  extraReducers: {
    [actionDeleteConfigPtMonDigital.pending]: (state) => {
      state.status = "loading"
    },
    [actionDeleteConfigPtMonDigital.fulfilled]: (state, { payload }) => {
      state.status = "success"
      state.data = payload
    },
    [actionDeleteConfigPtMonDigital.rejected]: (state, err) => {
      console.log(err)
      state.status = "error"
    },
  }
})

export default sliceDeleteConfigPtMonDigital.reducer
export const { actionResetDeleteConfigPtMonDigital } = sliceDeleteConfigPtMonDigital.actions